import React from "react";
import m from "@utils/strings";
import {
  TailSpin as TailSpinLoader,
  TailSpinProps,
} from "react-loader-spinner";
import Typography from "@material-ui/core/Typography";
import styled from "@emotion/styled";

interface ILoaderProps extends TailSpinProps {
  message?: string;
}

const LoaderContainer = styled.div<ILoaderProps>`
  display: ${(props) => (props.visible ? "flex" : "none")};
  position: absolute;
  place-items: center;
  place-content: center;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  backdrop-filter: blur(5px);
  z-index: 2;
`;

function Loader(props: ILoaderProps) {
  return (
    <LoaderContainer visible={props.visible}>
      <TailSpinLoader
        ariaLabel="loader"
        visible={props.visible}
        height="40"
        width="40"
        color="#767676"
        wrapperStyle={{marginBottom: "10px"}}
      />
      <Typography>
        {props.message ? props.message : m.GERAL.MENSAGEM_LOADER_VERIFICANDO}
      </Typography>
    </LoaderContainer>
  );
}

export default Loader;
